export const DIVISION_NAME = 'HP Wolf Security';
export const COMPANY_NAME_SHORT = 'HP Inc.';
export const PORTAL_NAME = 'HP Wolf Security Portal';
export const SURE_CLICK_NAME = 'Sure Click';
export const SURE_SENSE_NAME = 'Sure Sense';
export const CREDENTIAL_PROTECTION_NAME = 'Credential Protection';
export const SUPPORT_EMAIL = 'wpss.support@hpwolf.com';
export const ENTRA_ID = 'Entra ID';
export const WPT_NAME = 'Protect and Trace';
export const SCE_EDITION_UUID = '23561918-78d5-4f3d-8f08-607dd6174d77';
export const SURE_ADMIN_UUID = 'b8bf41e3-ec0f-4385-ab3a-6089d27b4d73';
export const WPS_EDITION_UUID = '89e41f9c-a8ac-4df4-82f4-90a75be35f77';
export const WPT_EDITION_UUID = '95e3b087-f2fa-4feb-93c6-67439da6501a';
